@let isArabic = isArabic$ | async;

<button type="button" [attr.aria-label]="(userId ? 'REPORT_PROFILE' : 'REPORT_TITLE') | translate" class="btn text-primary bg-dark" (click)="openModal($event)">
  @if (userId) {
    <i class="bi bi-flag" aria-hidden="true"></i>
    {{ 'REPORT_BUTTON' | translate }}
  } @else {
    <i class="bi bi-exclamation-octagon-fill" aria-hidden="true"></i>
  }
</button>

<div class="modal fade" [id]="modalId" tabindex="-1" [attr.aria-labelledby]="modalId + 'Label'">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header bg-dark text-primary">
        <h5 class="modal-title" [id]="modalId + 'Label'">{{ (userId ? 'REPORT_PROFILE' : 'REPORT_TITLE') | translate }}</h5>
      </div>

      <div class="modal-body text-center bg-dark">
        @if (categories$ | async; as categories) {
          <form [formGroup]="form" (ngSubmit)="submit()" novalidate>
            <!-- Reason -->
            <div class="form-group">
              <div class="row mb-3">
                <div class="col-12 pb-3">
                  <app-dropdown-checkbox-select
                    id="reasonSelect"
                    class="required multi-line-select"
                    [items]="categories.adReportReasons"
                    formControlName="reason"
                    placeholder="{{ 'REPORT_SELECT_REASON' | translate }}"
                    [selectableGroup]="false"
                    [isMultiple]="false"
                    [closeOnSelect]="true"
                    bindLabel="description"
                  >
                  </app-dropdown-checkbox-select>
                  @if (reason?.invalid && reason?.touched) {
                    <div class="invalid-feedback d-block">
                      @if (reason?.errors?.['required']) {
                        <div>{{ 'REPORT_SELECT_REASON' | translate }}</div>
                      }
                    </div>
                  }
                </div>
                <div class="col-12 pt-2">
                  <div class="row g-2">
                    <span class="col-3 text-light">{{
                      'CAR_NEW_SELECT_DESCRIPTION' | translate
                    }}</span>
                    <div class="col-9">
                      <textarea
                        class="form-control"
                        formControlName="comment"
                        id="comment"
                        rows="7"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            @if (images.length) {
              <label class="d-block my-2">{{ 'REPORT_IMAGE' | translate }}
                <select class="form-select" formControlName="imageUrl">
                  <option value="">{{ 'REPORT_WHOLE_CONTENT' | translate }}</option>
                  @for (image of images; track $index) { <option [value]="image">{{ 'REPORT_IMAGE' | translate }} {{ $index + 1 }}</option> }
                </select>
              </label>
            }
            <!-- Actions -->
            <div class="form-actions" [ngClass]="isArabic ? 'text-start' : 'text-end'">
              <button
                class="btn btn-primary"
                type="submit"
                [disabled]="form.invalid || isSubmitting"
              >
                {{ 'REPORT_BUTTON' | translate }}
                @if (isSubmitting) {
                  <app-loading
                    class="align-content-center"
                    [height]="20"
                    theme="dark"
                  ></app-loading>
                }
              </button>

              <button
                type="button"
                class="btn btn-secondary bg-black text-primary mx-3"
                (click)="close()"
              >
                <i class="bi bi-x-lg"></i>
              </button>
            </div>
          </form>
        }
      </div>
    </div>
  </div>
</div>
